import { FormHelperText, Radio, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  StyledTableCell,
  TableRowHead,
  useStyles,
} from "components/request-document/components/Commons";
import usePrevious from "libs/hooks/usePrevious";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectBranch } from "redux/modules/branchSlice";

export default function VisaIssuanceSection({
  formik,
  colSpan = 3,
  hideOverseas = false,
  hideThailand = false,
}) {
  const classes = useStyles();
  const branchState = useSelector(selectBranch);

  const branchList = get(branchState, "list", []);
  const countryIdThai = get(branchList, "0.countryId", null);
  const branchsThai = get(branchList, "0.branchs", []);
  const canEdit = useSelector(canEditForm);

  useEffect(() => {
    if (hideOverseas && !hideThailand) {
      formik.setFieldValue("visaissuance.countryId", countryIdThai);
    }
  }, [formik.values.visaissuance.branchID, hideOverseas, hideThailand]);

  const countryIdPrev = usePrevious(formik.values.visaissuance.countryId);
  useEffect(() => {
    if (
      !hideOverseas &&
      hideThailand &&
      countryIdPrev &&
      countryIdPrev !== formik.values.visaissuance.countryId
    ) {
      formik.setFieldValue("visaissuance.branchID", null);
    }
  }, [formik.values.visaissuance.countryId, hideOverseas, hideThailand]);

  return (
    <TableBody style={{ width: "100%" }}>
      <TableRowHead>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography variant="h6" className={classes.title}>
                Immigration stamp
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRowHead>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <InputLabel>
            Please select the place to collect the Smart Visa stamp (Please
            select only one).
          </InputLabel>
          <div className={classes.cellContent}>
            {!hideOverseas ? (
              <div className={classes.wrapField}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Radio
                        disabled={!canEdit}
                        name="visaissuance.overseas"
                        value={formik.values.visaissuance.overseas}
                        checked={Boolean(formik.values.visaissuance.overseas)}
                        onClick={() => {
                          formik.setFieldValue("visaissuance.overseas", true);
                          formik.setFieldValue("visaissuance.thailand", false);
                          formik.setFieldValue(
                            "visaissuance.theImmigrationBureauID",
                            null
                          );
                        }}
                      />
                    }
                    label="Overseas; Thai Embassy or Consulate in"
                  />

                  <div className={classes.flexRow}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      error={isError("visaissuance.countryId", formik)}
                      disabled={
                        formik.values.visaissuance.overseas ? false : true
                      }
                    >
                      <InputLabel>Country</InputLabel>
                      <Select
                        disabled={!canEdit}
                        label="Country"
                        name="visaissuance.countryId"
                        value={formik.values.visaissuance.countryId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {branchList.map((country) => (
                          <MenuItem
                            value={country.countryId}
                            key={country.countryId}
                          >
                            {country.countryName}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        error={isError("visaissuance.countryId", formik)}
                      >
                        {getErrorMessage("visaissuance.countryId", formik)}
                      </FormHelperText>
                    </FormControl>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      error={isError("visaissuance.branchID", formik)}
                      disabled={
                        formik.values.visaissuance.overseas ? false : true
                      }
                    >
                      <InputLabel>City</InputLabel>
                      <Select
                        disabled={!canEdit}
                        label="City"
                        name="visaissuance.branchID"
                        value={formik.values.visaissuance.branchID}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {get(
                          branchList.find(
                            (country) =>
                              country.countryId ===
                              formik.values.visaissuance.countryId
                          ),
                          "branchs",
                          []
                        ).map((country) => (
                          <MenuItem
                            value={country.branchID}
                            key={country.branchID}
                          >
                            {country.branchName}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        error={isError("visaissuance.branchID", formik)}
                      >
                        {getErrorMessage("visaissuance.branchID", formik)}
                      </FormHelperText>
                    </FormControl>
                  </div>
                </FormGroup>
              </div>
            ) : (
              <br />
            )}
          </div>

          {!hideThailand && (
            <div className={classes.cellContent}>
              <div className={classes.wrapField}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Radio
                        disabled={!canEdit}
                        name="visaissuance.thailand"
                        value={formik.values.visaissuance.thailand}
                        checked={Boolean(formik.values.visaissuance.thailand)}
                        onClick={() => {
                          formik.setFieldValue("visaissuance.thailand", true);
                          formik.setFieldValue("visaissuance.overseas", false);
                          formik.setFieldValue("visaissuance.branchID", null);
                          formik.setFieldValue(
                            "visaissuance.countryId",
                            countryIdThai
                          );
                        }}
                      />
                    }
                    label="Thailand"
                  />
                  <div className={classes.flexRow} style={{ flex: 1 }}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: "100%" }}
                      error={isError("visaissuance.branchID", formik)}
                      disabled={
                        formik.values.visaissuance.thailand ? false : true
                      }
                    >
                      <InputLabel>The Immigration Bureau</InputLabel>
                      <Select
                        disabled={!canEdit}
                        label="The Immigration Bureau"
                        name="visaissuance.branchID"
                        id="visaissuance.branchID"
                        key={formik.values.visaissuance.thailand}
                        value={formik.values.visaissuance.branchID}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {branchsThai.map((branch) => (
                          <MenuItem
                            value={branch.branchID}
                            key={branch.branchID}
                          >
                            {branch.branchName} - {branch.branchAddress}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        error={isError("visaissuance.branchID", formik)}
                      >
                        {getErrorMessage("visaissuance.branchID", formik)}
                      </FormHelperText>
                    </FormControl>
                  </div>
                </FormGroup>
              </div>
            </div>
          )}

          <br />
        </StyledTableCell>
      </TableRow>

      <TableRowHead>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography variant="h6" className={classes.title}>
                Arrival Stamp
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRowHead>
      <TableRow>
        <StyledTableCell>
          <DatePicker
            disabled={!canEdit}
            inputVariant="outlined"
            name={`visaissuance.dateofArrival`}
            className={classes.formControl}
            disableFuture={false}
            openTo="year"
            format="DD-MM-YYYY"
            label="Date of Arrival"
            views={["year", "month", "date"]}
            value={formik.values.visaissuance?.dateofArrival || null}
            onChange={(date) => {
              formik.setFieldValue(
                `visaissuance.dateofArrival`,
                date.format("YYYY-MM-DD")
              );
            }}
            error={isError(`visaissuance.dateofArrival`, formik)}
            helperText={getErrorMessage(`visaissuance.dateofArrival`, formik)}
          />
          <DatePicker
            disabled={!canEdit}
            inputVariant="outlined"
            name={`visaissuance.untilDate`}
            className={classes.formControl}
            disableFuture={false}
            openTo="year"
            format="DD-MM-YYYY"
            label="Until Date"
            views={["year", "month", "date"]}
            value={formik.values.visaissuance?.untilDate || null}
            onChange={(date) => {
              formik.setFieldValue(
                `visaissuance.untilDate`,
                date.format("YYYY-MM-DD")
              );
            }}
            error={isError(`visaissuance.untilDate`, formik)}
            helperText={getErrorMessage(`visaissuance.untilDate`, formik)}
          />
        </StyledTableCell>
      </TableRow>

      <div />
    </TableBody>
  );
}
